"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuoteLineItemNumberField = void 0;
var QuoteLineItemContext_1 = require("@CommonFrontend/ContentTokens/SharedWidgetComponents/QuoteLineItem/QuoteLineItemContext");
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var react_1 = __importStar(require("react"));
var styles = __importStar(require("./QuoteLineItemNumberField.css"));
var MaybeWrap_1 = __importDefault(require("@CommonFrontend/Utils/MaybeWrap"));
var useQuoteCurrencyFormatter_1 = require("@CommonFrontendBackend/QuoteWidgets/useQuoteCurrencyFormatter");
var QuoteLineItemNumberField = function (_a) {
    var field = _a.field;
    var _b = (0, QuoteLineItemContext_1.useQuoteLineItemContext)(), item = _b.item, actions = _b.actions;
    var _c = __read((0, react_1.useState)(false), 2), inputIsFocussed = _c[0], setInputIsFocussed = _c[1];
    var currencyFormatter = (0, useQuoteCurrencyFormatter_1.useQuoteCurrencyFormatter)();
    if (field.userEditable) {
        return (react_1.default.createElement(kaleidoscope_1.Stack, { direction: "horizontal", align: "center", gap: "xxs" },
            react_1.default.createElement(MaybeWrap_1.default, { wrapper: function (children) {
                    var controlledField = item.customFields.find(function (f) {
                        return f.type === "currency" && f.strategy === "volume" && f.controllingFieldId === field.id;
                    });
                    if (controlledField) {
                        return (react_1.default.createElement(kaleidoscope_1.Tooltip, { theme: "light", className: styles.volumePricingTooltip, show: inputIsFocussed ? true : undefined, size: kaleidoscope_1.TooltipSize.Large, content: react_1.default.createElement(kaleidoscope_1.Stack, { padding: "s", gap: "s" },
                                react_1.default.createElement(kaleidoscope_1.Text, { strong: true, size: "s" }, "Volume pricing"),
                                react_1.default.createElement(kaleidoscope_1.Stack, { gap: "s" },
                                    react_1.default.createElement(kaleidoscope_1.Stack, { direction: "horizontal", justify: "spaceBetween" },
                                        react_1.default.createElement(kaleidoscope_1.Text, { strong: true, size: "xs" }, "Quantity"),
                                        react_1.default.createElement(kaleidoscope_1.Text, { strong: true, size: "xs" }, "Item")),
                                    react_1.default.createElement(kaleidoscope_1.Separator, null),
                                    react_1.default.createElement(kaleidoscope_1.Stack, { direction: "horizontal", justify: "spaceBetween" },
                                        react_1.default.createElement(kaleidoscope_1.Text, { strong: true, size: "xs" }, !!controlledField.tiers[0] ? "Under ".concat(controlledField.tiers[0].minimumThreshold) : "1+"),
                                        react_1.default.createElement(kaleidoscope_1.Text, { strong: true, size: "xs" }, currencyFormatter.format(controlledField.baseValue))),
                                    controlledField.tiers.map(function (tier) { return (react_1.default.createElement(kaleidoscope_1.Stack, { gap: "s", key: tier.minimumThreshold },
                                        react_1.default.createElement(kaleidoscope_1.Separator, null),
                                        react_1.default.createElement(kaleidoscope_1.Stack, { direction: "horizontal", justify: "spaceBetween" },
                                            react_1.default.createElement(kaleidoscope_1.Text, { strong: true, size: "xs" },
                                                tier.minimumThreshold,
                                                "+"),
                                            react_1.default.createElement(kaleidoscope_1.Text, { strong: true, size: "xs" }, currencyFormatter.format(tier.value))))); }))) }, children));
                    }
                    return children;
                } },
                react_1.default.createElement(kaleidoscope_1.NumberInput, { autoGrow: true, label: field.label, labelHidden: true, variant: "underlined", size: "s", value: field.value, onChange: function (value) {
                        actions.setNumberFieldValue(field.id, value);
                    }, min: field.min, max: field.max, step: field.step, onFocus: function () {
                        setInputIsFocussed(true);
                    }, onBlur: function () {
                        setInputIsFocussed(false);
                    } })),
            field.unit && react_1.default.createElement(kaleidoscope_1.Text, null, field.unit)));
    }
    var displayValue = field.unit ? "".concat(field.value, " ").concat(field.unit) : field.value.toString();
    return react_1.default.createElement("div", null, displayValue);
};
exports.QuoteLineItemNumberField = QuoteLineItemNumberField;
